import { useEffect, useState } from "react";
import { Table, Tag } from "antd";
import { AccountHistoryService } from "../../../services/AccountHistoryService";
import { AccountHistoryColumns } from "../../../constants/AccountHistoryColumns";

const enrichedColumns = AccountHistoryColumns.map((col) => {
  if (col.dataIndex === 'creditOrDebit') {
    return {
      ...col,
      render: (val) => (
        <Tag color={val === 'Credit' ? 'success' : 'error'} style={{ fontWeight: 600 }}>
          {val}
        </Tag>
      ),
    };
  }
  if (col.dataIndex === 'amount') {
    return {
      ...col,
      render: (val) => `$${Number(val).toLocaleString('en-US', { minimumFractionDigits: 2 })}`,
    };
  }
  return col;
});

export const HistoryList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    new AccountHistoryService()
      .getAccountHistory()
      .then((result) => {
        setData(result);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <Table
      rowKey="id"
      size="middle"
      columns={enrichedColumns}
      dataSource={data}
      loading={loading}
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total) => `${total} transactions`,
      }}
      scroll={{ x: 600 }}
    />
  );
};
